import { encodeBase64, encodeJson } from '@/common/util/util.js';
import { suggest } from '@/restapi/product/product.js';
import { searchWithKindGroup } from '@/restapi/tag/tag.js';


export default {
    methods: {
        suggest,
        searchWithKindGroup,
        doSearch(query, tags) {
            this.$router.push({
                name: 'home',
                query: {
                    filter: encodeBase64(encodeJson({
                        query,
                        tags,
                    })),
                },
            });
        },
    },
};
